module.exports = __webpack_public_path__ + "static/img/vip_privilege10.dc66422.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip/vip_privilege10.png
// module id = vOHq
// module chunks = 0